import { render, staticRenderFns } from "./SendCodeScreen.vue?vue&type=template&id=230e1df0"
import script from "./SendCodeScreen.vue?vue&type=script&lang=js"
export * from "./SendCodeScreen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports